import { Card, CardAction, CardContent, CardHeader, CardTitle } from '@repo/ui/card'
import { DataProvider } from '@repo/ui/dataProvider'
import { useT } from '@repo/ui/hooks'

import { DataTable } from '@/components/admin/members/data-table'
import { UserCreator } from '@/components/sudo/user/Creator'
import { usersColumns } from '@/components/sudo/user/users-columns'
import { RootState } from '@/store'
import { SudoContextUser } from '@/store/sudo'

export function UserList({ users }: { users: SudoContextUser[] }) {
  const { tc } = useT()
  return (
    <Card>
      <CardHeader>
        <CardTitle>{tc('user', { cfl: true, count: users.length })}</CardTitle>
        <CardAction>
          <DataProvider
            selectors={[(state: RootState) => state.sudo.organizations]}
            render={(organizations) => <UserCreator organizations={organizations} />}
          />
        </CardAction>
      </CardHeader>
      <CardContent>
        <DataTable
          columns={usersColumns}
          data={users}
          initialState={{
            sorting: [
              {
                id: 'disabled',
                desc: false,
              },
              {
                id: 'lastName',
                desc: false,
              },
            ],
          }}
        />
      </CardContent>
    </Card>
  )
}
